import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react'

import { PageTitle } from '../../../components/PageTitle'
import UrlRedirectorPage from './UrlRedirector/UrlRedirectorPage'
import UtmGeneratorPage from './UtmGenerator/UtmGeneratorPage'
import UtmListPage from './UtmGenerator/UtmListPage'

interface IUrlShortenerPage {
  used_by: 'commercial' | 'marketing'
}

export default function UrlShortenerPage({ used_by }: IUrlShortenerPage) {
  return (
    <>
      <PageTitle
        title={used_by === 'marketing' ? "Gerenciador de URL's - Marketing" : "Gerador de UTM's - Comercial"}
        description="Links encurtados e parâmetros de campanha"
      />

      {used_by === 'commercial' ? (
        <Tabs isLazy>
          <TabList>
            <Tab>Gerador de UTM&apos;s</Tab>
            <Tab>Listagem de UTM&apos;s</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <UtmGeneratorPage used_by="commercial" />
            </TabPanel>
            <TabPanel>
              <UtmListPage used_by="commercial" />
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <Tabs isLazy>
          <TabList>
            <Tab>Gerador de UTM&apos;s</Tab>
            <Tab>Redirecionador de URL</Tab>
            <Tab>Listagem de UTM&apos;s</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <UtmGeneratorPage used_by="marketing" />
            </TabPanel>
            <TabPanel>
              <UrlRedirectorPage />
            </TabPanel>
            <TabPanel>
              <UtmListPage used_by="marketing" />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </>
  )
}
